import debug from 'debug'
import { Record } from 'immutable'

export const log = debug('{HKLD}')

/**
 * Create dot-notation immutable value object via immutable Record template.
 * @param {Object} values - values to be locked via immutable system.
 */
export const create = (values = {}) => new Record(values)(values)

/**
 * Traverse  and update the Object literal with updated full path values (dot-notation).
 * @param {String} ns - dot-notation based namespace starts with application folder name.
 * @param {Object} values - Object literal.
 */
const traverse = (ns, values = {}) => {
  Object.entries(values).forEach(([k, v]) => {
    if (v && typeof v === 'object') {
      traverse(`${ns}.${k}`, v)
    } else {
      values[k] = v ? `${ns}.${k}.${v}` : `${ns}.${k}`
    }
  })
  return values
}

/**
 * Create dot-notation immutable value object via immutable Record template
 * under the auto-detected namespace. Additionally,
 * values in the constructed object will be automatically populated in
 * `${NS}.${key}.${value}` format.
 * @param {*} values
 */
export const createKeyMirror = (namespace, values = {}) => {
  return create(traverse(namespace, values))
}

export const isJsonObject = (value) => {
  if (typeof value !== 'string') {
    return false
  }
  try {
    const jsonVal = JSON.parse(value)
    return typeof jsonVal === 'object' && jsonVal !== null
  } catch (e) {
    return false
  }
}
